import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.CalendarSliderRoot),
  () => import('./CalendarSlider'),
  (Slider) => {
    ComponentUtil.binder(Hooks.CalendarSliderRoot, Slider);
  },
);
